import { HTMLAttributes, ReactNode } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'

interface AlertProps extends HTMLAttributes<HTMLDivElement> {
  children?: ReactNode;
}

export default function Alert (props: AlertProps) {
  const { children, className, ...rest } = props

  return (
    <div className={cn(styles.root, className)} {...rest}>
      {children}
    </div>
  )
}
